// client/src/modules/workshop/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Workshop module manifest (P19)
 *
 * Per-user productivity utilities — letters, investor updates, briefs,
 * meeting prep, e-sign, drafting, research, narratives, workflows.
 * Different roles get different tool surfaces via per-user entitlement
 * (see docs/architecture/workshop-module.md §6).
 *
 * Multi-user, AI-driven, context-rich.
 */
export const workshopModule: ModuleManifest = {
  id: 'P19',
  name: 'Workshop',
  shortName: 'Workshop',
  description: 'Per-user productivity utilities — letters, investor updates, briefs, meeting prep, e-sign, drafting, research, narratives, workflows',
  icon: 'Wrench',
  status: 'live',
  urlPrefix: '/workshop',
  routes,
  navItems,
  collections: {
    // Framework
    WORKSHOP_TOOL_GRANTS: 'workshopToolGrants',
    WORKSHOP_TOOL_ORG_CONFIGS: 'workshopToolOrgConfigs',
    WORKSHOP_GRANT_AUDIT: 'workshopGrantAudit',
    // Tool 1: Outreach Letters
    OUTREACH_SENDER_PROFILES: 'outreachSenderProfiles',
    OUTREACH_CONTACTS: 'outreachContacts',
    OUTREACH_LETTERS: 'outreachLetters',
    OUTREACH_RESEARCH_SESSIONS: 'outreachResearchSessions',
  },
};

export default workshopModule;
